import { element } from '../../../util/element';

export default function template(data = {}) {
  const { isNoCardsError } = data;

  return [
    element(
      'div#genericErrorMsg.error.hide',
      element('span.errorMessageInline', 'Oops! Looks like we’re experiencing some technical difficulties. Please try again.'),
    ),

    isNoCardsError ?
      element('div#add-credit-card-msg.align-center', [
        element('p', "We’re sorry, but we are unable to access your Macy's Credit Card account."),
        element('p', "It could be because your card has not yet been added to your Macy's profile. To be able to manage your account online, please add it to your profile now."),
        element('a.primary-button.addMyCard.margin-bottom-xxs', { href: '#' }, 'ADD MY CARD'),
        element('p', [
          "If your card has already been added to your Macy's profile, or if you continue to have difficulties accessing your account,  please contact Customer Service at",
          element('a', { type: 'tel' }, '1-877-493-9207.'),
        ]),
      ]) :
      element(
        'div.row',
        element(
          'div#spinner-container.padding-top-xxs',
          element(
            'div#overlay-spinner.loader-container',
            element('div.spinner-loader'),
          ),
        ),
      ),

  ];
}
